import Delete from '@mui/icons-material/Delete'
import Download from '@mui/icons-material/Download'
import {
  IconButton,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import dayjs from 'dayjs'
import { FC, PropsWithChildren } from 'react'
import {
  useDeleteObjectStoreFile,
  useObjectStoreFiles,
} from '../../../hooks/data/useObjectStoreFiles'
import { useUserRole } from '../../../hooks/useUserRole'
import { pickChildrenByType } from '../../../utils/childrenPickers'
import { SPACES_FOLDER } from '../constants'

const Actions: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Stack alignItems="end" direction="row" spacing={1}>
      {children}
    </Stack>
  )
}

export const ReportsTable: FC<PropsWithChildren<{ reportType: string; farmId: string }>> & {
  Actions: FC<PropsWithChildren>
} = ({ reportType, farmId, children }) => {
  const { isAdmin } = useUserRole()

  const folder = reportType
    ? `farms/${farmId}/reports/${SPACES_FOLDER[reportType] || reportType}`
    : undefined
  const { data: reports = [], isLoading } = useObjectStoreFiles(folder)
  const { mutate: deleteReport } = useDeleteObjectStoreFile(folder)

  const handleDownload = (url: string) => {
    window.open(url, '_blank noopener noreferrer')
  }

  if (!reportType) return null

  const actions = pickChildrenByType(children, Actions)

  return (
    <Stack alignItems="end" spacing={1}>
      {actions}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Fecha</b>
              </TableCell>
              <TableCell>
                <b>Nombre</b>
              </TableCell>
              <TableCell>
                <b>Acciones</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!isLoading ? (
              reports.length > 0 ? (
                reports.map(row => (
                  <TableRow key={row.key}>
                    <TableCell>{dayjs(row.lastModified).format('DD/MM/YYYY HH:mm')}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell sx={{ display: 'flex', gap: 1 }}>
                      <IconButton color="primary" onClick={() => handleDownload(row.downloadUrl)}>
                        <Download />
                      </IconButton>
                      {isAdmin && (
                        <IconButton color="error" onClick={() => deleteReport(row.key)}>
                          <Delete />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan={3}>
                    No se encontraron reportes
                  </TableCell>
                </TableRow>
              )
            ) : (
              Array.from(new Array(3)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <TableRow key={index}>
                  <TableCell>
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell>
                    <Skeleton height={40} variant="rectangular" width={40} />
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

ReportsTable.Actions = Actions
